module.exports = __webpack_public_path__ + "static/img/logo2.f1d91e63.png";